const config = {
  env: 'beta',
  baseUrl: 'https://beta-api.dimorder.com',
  nodeApiUrl: 'https://beta-node.dimorder.com',
  basePriceUrl: 'https://beta-delivery-price.dimorder.com',
}

export default config
